module.exports = __webpack_public_path__ + "img/wallonia-histogram.eb2c95e6.svg";